import { ConfirmationSummaryShareDesignStateEnum } from '@inter-ikea-kompis/component-configuration-summary';

/* TODO: Turn this one (including VpcSaveProgressStatusEnumType below) into a
   real enum once our TypeScript version supports it. */
export const VpcSaveProgressStatusEnum = {
  default: 'default',
  saving: 'saving',
  success: 'success',
  failure: 'failure',
};

export type VpcSaveProgressStatusEnumType = string;

export type Vpc = {
  load: {
    code: string;
    state: boolean;
  };
  save: {
    code: string;
    state: ConfirmationSummaryShareDesignStateEnum;
    dirtyConfiguration: boolean;
    progressStatus: VpcSaveProgressStatusEnumType;
  };
  vpcErrorList: [];
};

export type VpcStoredAction = string;

export interface VpcLoadedAction {
  currentView: string;
  code: string;
}
